/**
 * Christmas Ornament Hunt Game
 * Users need to find 5 hidden ornaments across the website
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    TOTAL_ORNAMENTS: 5,
    ORNAMENTS_PER_PAGE: [1, 2], // Random 1 or 2 per page
    STORAGE_KEY: 'christmas_ornaments_found',
    POPUP_STATE_KEY: 'christmas_popup_minimized',
    COMPLETION_URL: '/collections/vanocni-nadilka', // Change this to your desired completion page
    IMAGE_URL: 'https://cdn.shopify.com/s/files/1/0823/9038/4983/files/botas-ozdoba.png?v=1766054038',
    DESKTOP_SIZE: 150, // px
    MOBILE_SIZE: 100, // px
    MOBILE_BREAKPOINT: 768 // px
  };

  // Get found ornaments from localStorage
  function getFoundOrnaments() {
    try {
      const found = localStorage.getItem(CONFIG.STORAGE_KEY);
      return found ? JSON.parse(found) : [];
    } catch (e) {
      return [];
    }
  }

  // Save found ornaments to localStorage
  function saveFoundOrnaments(ornaments) {
    try {
      localStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(ornaments));
    } catch (e) {
      console.error('Failed to save ornaments:', e);
    }
  }

  // Get a consistent random number for this page
  function getPageSeed() {
    const path = window.location.pathname;
    let hash = 0;
    for (let i = 0; i < path.length; i++) {
      const char = path.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return Math.abs(hash);
  }

  // Seeded random number generator
  function seededRandom(seed) {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  }

  // Generate random positions for ornaments on this page
  function generateOrnamentPositions(count, seed, container) {
    const positions = [];
    const padding = 50; // px from edges
    const containerHeight = container.scrollHeight;
    const containerWidth = container.offsetWidth;
    
    for (let i = 0; i < count; i++) {
      const posSeed = seed + i * 1000;
      
      // Random position within the container
      const top = padding + seededRandom(posSeed) * (containerHeight - padding * 2 - CONFIG.DESKTOP_SIZE);
      const left = padding + seededRandom(posSeed + 1) * (containerWidth - padding * 2 - CONFIG.DESKTOP_SIZE);
      
      positions.push({ top, left });
    }
    
    return positions;
  }

  // Create ornament element
  function createOrnament(id, position) {
    const ornament = document.createElement('div');
    ornament.className = 'christmas-ornament';
    ornament.dataset.ornamentId = id;
    ornament.style.top = position.top + 'px';
    ornament.style.left = position.left + 'px';
    
    const img = document.createElement('img');
    img.src = CONFIG.IMAGE_URL;
    img.alt = 'Vánoční koule';
    img.draggable = false;
    
    ornament.appendChild(img);
    
    // Click handler
    ornament.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      handleOrnamentClick(id, ornament);
    });
    
    return ornament;
  }

  // Handle ornament click
  function handleOrnamentClick(ornamentId, element) {
    const found = getFoundOrnaments();
    
    if (found.includes(ornamentId)) {
      return; // Already found
    }
    
    // Add to found list
    found.push(ornamentId);
    saveFoundOrnaments(found);
    
    // Animate collection
    element.classList.add('collected');
    
    setTimeout(() => {
      element.remove();
      updateProgress();
      
      // Check if game completed
      if (found.length >= CONFIG.TOTAL_ORNAMENTS) {
        showCompletionMessage();
      }
    }, 600);
  }

  // Create progress popup
  function createProgressPopup() {
    const popup = document.createElement('div');
    popup.id = 'christmas-game-popup';
    popup.className = 'christmas-popup';
    
    const found = getFoundOrnaments();
    
    popup.innerHTML = `
      <div class="christmas-popup__header">
        <span class="christmas-popup__title">
          <span class="christmas-popup__title-full">🎄 Vánoční hra</span>
          <span class="christmas-popup__title-icon" style="display: none;">
            <div class="christmas-popup__circle-content">
              <span class="christmas-popup__circle-emoji">🎄</span>
              <span class="christmas-popup__circle-counter">${found.length}/${CONFIG.TOTAL_ORNAMENTS}</span>
            </div>
          </span>
        </span>
        <button class="christmas-popup__close" aria-label="Zavřít">×</button>
      </div>
      <div class="christmas-popup__content">
        <p class="christmas-popup__text">Najděte všechny vánoční koule a získejte odměnu!</p>
        <div class="christmas-popup__progress">
          <div class="christmas-popup__counter">
            <span class="christmas-popup__found">${found.length}</span>
            <span class="christmas-popup__separator">/</span>
            <span class="christmas-popup__total">${CONFIG.TOTAL_ORNAMENTS}</span>
          </div>
          <div class="christmas-popup__bar">
            <div class="christmas-popup__bar-fill"></div>
          </div>
        </div>
        <div class="christmas-popup__completion" style="display: none;">
          <p class="christmas-popup__completion-text">🎉 Gratulujeme! Našli jste všechny koule!</p>
          <a href="${CONFIG.COMPLETION_URL}" class="christmas-popup__cta">Jdu si pro odměnu</a>
        </div>
      </div>
    `;
    
    document.body.appendChild(popup);
    
    // Toggle handler for mobile - click anywhere on header
    const header = popup.querySelector('.christmas-popup__header');
    const titleFull = popup.querySelector('.christmas-popup__title-full');
    const titleIcon = popup.querySelector('.christmas-popup__title-icon');
    
    const togglePopup = () => {
      const isMinimized = popup.classList.toggle('minimized');
      
      // Switch between full title and just emoji
      if (isMinimized) {
        titleFull.style.display = 'none';
        titleIcon.style.display = 'block';
        // Save minimized state
        try {
          localStorage.setItem(CONFIG.POPUP_STATE_KEY, 'true');
        } catch (e) {}
      } else {
        titleFull.style.display = 'block';
        titleIcon.style.display = 'none';
        // Save expanded state
        try {
          localStorage.setItem(CONFIG.POPUP_STATE_KEY, 'false');
        } catch (e) {}
      }
    };
    
    header.addEventListener('click', togglePopup);
    
    // Close button handler (desktop)
    const closeBtn = popup.querySelector('.christmas-popup__close');
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePopup();
    });
    
    // Check if popup should be minimized on load
    try {
      const isMinimized = localStorage.getItem(CONFIG.POPUP_STATE_KEY);
      if (isMinimized === 'true') {
        popup.classList.add('minimized');
        titleFull.style.display = 'none';
        titleIcon.style.display = 'block';
      }
    } catch (e) {}
    
    return popup;
  }

  // Update progress display
  function updateProgress() {
    const found = getFoundOrnaments();
    const popup = document.getElementById('christmas-game-popup');
    
    if (!popup) return;
    
    const foundEl = popup.querySelector('.christmas-popup__found');
    const barFill = popup.querySelector('.christmas-popup__bar-fill');
    const completionEl = popup.querySelector('.christmas-popup__completion');
    const circleCounter = popup.querySelector('.christmas-popup__circle-counter');
    
    if (foundEl) {
      foundEl.textContent = found.length;
    }
    
    if (circleCounter) {
      circleCounter.textContent = `${found.length}/${CONFIG.TOTAL_ORNAMENTS}`;
    }
    
    if (barFill) {
      const percentage = (found.length / CONFIG.TOTAL_ORNAMENTS) * 100;
      barFill.style.width = percentage + '%';
    }
    
    // Show completion message
    if (found.length >= CONFIG.TOTAL_ORNAMENTS && completionEl) {
      completionEl.style.display = 'block';
    }
  }

  // Show completion message
  function showCompletionMessage() {
    const popup = document.getElementById('christmas-game-popup');
    if (!popup) return;
    
    popup.classList.remove('minimized');
    popup.classList.add('completed');
  }

  // Initialize game
  function initGame() {
    // Don't run on checkout or other excluded pages
    if (window.location.pathname.includes('pokladna') || 
        window.location.pathname.includes('checkout') ||
        window.location.pathname.includes('status')) {
      return;
    }
    
    const found = getFoundOrnaments();
    
    // Check if game already completed
    if (found.length >= CONFIG.TOTAL_ORNAMENTS) {
      // Still show popup with completion message
      createProgressPopup();
      updateProgress();
      return;
    }
    
    // Create progress popup
    createProgressPopup();
    updateProgress();
    
    // Determine how many ornaments on this page
    const pageSeed = getPageSeed();
    const ornamentsCount = CONFIG.ORNAMENTS_PER_PAGE[Math.floor(seededRandom(pageSeed) * CONFIG.ORNAMENTS_PER_PAGE.length)];
    
    // Calculate which ornament IDs to show on this page
    const pageOrnamentIds = [];
    
    // First, try to add unfound ornaments based on page seed
    for (let i = 0; i < ornamentsCount; i++) {
      const ornamentId = (pageSeed % CONFIG.TOTAL_ORNAMENTS) + i;
      const finalId = ornamentId % CONFIG.TOTAL_ORNAMENTS;
      
      // Only show if not already found
      if (!found.includes(finalId)) {
        pageOrnamentIds.push(finalId);
      }
    }
    
    // If no ornaments were added (all were found), add any remaining unfound ornament
    if (pageOrnamentIds.length === 0) {
      for (let id = 0; id < CONFIG.TOTAL_ORNAMENTS; id++) {
        if (!found.includes(id)) {
          pageOrnamentIds.push(id);
          break; // Add at least one
        }
      }
    }
    
    // Find the main content container
    const container = document.getElementById('MainContent') || document.body;
    
    // Ensure container has position relative for absolute positioning
    if (container && window.getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }
    
    // Generate positions
    const positions = generateOrnamentPositions(pageOrnamentIds.length, pageSeed, container);
    
    // Create ornaments and append to container
    pageOrnamentIds.forEach((id, index) => {
      const ornament = createOrnament(id, positions[index]);
      container.appendChild(ornament);
    });
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGame);
  } else {
    initGame();
  }

  // Debug: Reset game (remove this in production or add a secret key combo)
  window.resetChristmasGame = function() {
    localStorage.removeItem(CONFIG.STORAGE_KEY);
    location.reload();
  };

})();

